// import ThemePresenter from './presenters/ThemePresenter';
// import 'globalStyles/theme.scss';

import { EventEmitter } from '@firenet-designs/shopify-common'

import RemoveElPresenter from './RemoveElPresenter.js';
import LoginRedirectPresenter from './LoginRedirectPresenter.js';

EventEmitter.polyfill();


const FND = (window.FND = window.FND || {});
FND.BUILDS = FND.BUILDS || {};
FND.BUILDS.Theme = FND.BUILDS.Theme || {};
FND.BUILDS.Theme.removeElements = new RemoveElPresenter;
FND.BUILDS.Theme.LoginRedirect = new LoginRedirectPresenter;